import React from "react";
import Icon from "./Icon";
export default function Edit(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 3.66667H3.66659C3.18035 3.66667 2.71404 3.85982 2.37022 4.20364C2.02641 4.54745 1.83325 5.01377 1.83325 5.5V18.3333C1.83325 18.8196 2.02641 19.2859 2.37022 19.6297C2.71404 19.9735 3.18035 20.1667 3.66659 20.1667H16.4999C16.9861 20.1667 17.4525 19.9735 17.7963 19.6297C18.1401 19.2859 18.3333 18.8196 18.3333 18.3333V11.9167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 2.29167C17.3229 1.92699 17.8175 1.72212 18.3333 1.72212C18.849 1.72212 19.3436 1.92699 19.7083 2.29167C20.0729 2.65634 20.2778 3.15094 20.2778 3.66667C20.2778 4.18239 20.0729 4.67699 19.7083 5.04167L10.9999 13.75L7.33325 14.6667L8.24992 11L16.9583 2.29167Z"
  }));
}
Edit.displayname = "Edit";
//# sourceMappingURL=Edit.js.map